/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CaptionText, HeadingText } from '@paypalcorp/pp-react';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Message } from '@paypalcorp/worldready-react';
import { CONTACT_CALL_US, CONTACT_TOPIC_TREE_INTENTS, PERSISTENT_EMAIL_FORM } from '../../common/storeConstants';
import doMobileWebHelpIvrAuth from '../../../js/contactUs/actions/action-ivr-auth-web';
import { FPTI_DATA } from '../../common/propTypes';
import { generateLinkData, trackActivityEvent, trackClickEvent } from '../../helpers/analytics/fptiHelper';
import useLoaderHook from '../../shared/hooks/useLoaderHook';
import LoaderOverlay from '../../shared/LoaderOverlay';
import { redirectLocation } from '../../../js/contactUs/actions/action-contact-location';
import { loadModalContainer } from '../../../js/contactUs/actions/action-login-modal';
import { modalChannels } from '../../../js/contactUs/constants/UtilVariables';
import transformCallUsInfo from './callUsHelper';
import Dialing from './Dialing';
import WebPinCard from './WebPinCard';
import { isLoggedIn, isMobileAuthWebStepUpEnabledCountries, isMobileLayout } from '../../helpers/twHelper';

const CallUsInfo = function (props) {
  const { callUsInfo, isLoading, chatParams } = useSelector((state) => state[CONTACT_CALL_US]);
  const { selectedFinalIntent } = useSelector((state) => state[CONTACT_TOPIC_TREE_INTENTS]);
  const { fields: formFields } = useSelector((state) => state[PERSISTENT_EMAIL_FORM]);
  const dispatch = useDispatch();

  const [transformedCallUsInfo, setTransformedCallUsInfo] = useState();

  const { FPTIData, pageName } = props;
  const { ref_id: topicRefId = '' } = { ...selectedFinalIntent };

  const { enableSpinner } = useLoaderHook(() => {}, [isLoading]);

  useEffect(() => {
    const callUsData = transformCallUsInfo(callUsInfo, formFields, !!topicRefId, chatParams);
    setTransformedCallUsInfo(callUsData);
  }, [callUsInfo, formFields, topicRefId, chatParams]);

  useEffect(() => {
    if (callUsInfo && !_isEmpty(callUsInfo)) {
      trackActivityEvent({
        ...FPTIData.callUsPageShown,
        link: generateLinkData(FPTIData.callUsPageShown.link, { topicRefId }),
      });
      // fire redirect to callUs page
      dispatch(redirectLocation({ pageName }));
    }
  }, [callUsInfo]);

  const loginClick = (e) => {
    e.preventDefault();
    trackClickEvent({ ...FPTIData.callUsLoginBtnClick });
    return dispatch(loadModalContainer(modalChannels.call));
  };

  const doWebPinAuthCall = (e, phoneNo) => {
    e.preventDefault();
    const fptiData = {
      ...FPTIData.callUsPhoneNumberClick,
      link: generateLinkData(FPTIData.callUsPhoneNumberClick.link, { phoneNo }),
    };
    trackClickEvent(fptiData);

    const options = {
      webPin: callUsInfo.web_pin,
      number: phoneNo,
    };

    if (isMobileAuthWebStepUpEnabledCountries() && isLoggedIn()) {
      dispatch(doMobileWebHelpIvrAuth(options));
    }

    return window.open(`tel:${phoneNo}`, '_self');
  };

  const displayHeader = () => (
    <>
      <HeadingText size="sm" className="sh_callUs_info_heading_one" data-testid="sh-callUs-info-heading-one">
        <Message id="smarthelp.app.callUs.heading.instructions" />
      </HeadingText>
      <CaptionText size="md" className="sh_callUs_info_heading_two" data-testid="sh-callUs-info-heading-two">
        <Message id="smarthelp.app.callUs.heading.phoneNumber" />
      </CaptionText>
    </>
  );

  const renderDialinginfo = () => {
    return <Dialing FPTIData={FPTIData} callUsInfo={transformedCallUsInfo} onWebPinClick={doWebPinAuthCall} />;
  };

  const renderWebPin = () => {
    return <WebPinCard FPTIData={FPTIData} onLoginClick={loginClick} callUsInfo={transformedCallUsInfo} />;
  };

  const renderAccountInfoSharingMsg = () => {
    return <Message id="smarthelp.app.callUs.account.informationShare.message" />;
  };

  const callUsInfoWeb = () => {
    return (
      <>
        <hr className="sh_callUs_divider" />
        {displayHeader()}
        <div className="sh_callUs_container" data-testid="sh-callUs-container">
          <div className="sh_callUs_dialing">{renderDialinginfo()}</div>
          <div className="sh_callUs_webpin">{renderWebPin()}</div>
        </div>
        <div className="sh_callUs_account_info_sharing_msg">{renderAccountInfoSharingMsg()}</div>
      </>
    );
  };

  const callUsInfoMobile = () => {
    return (
      <>
        <hr className="sh_callUs_divider" />
        {displayHeader()}
        <div className="sh_callUs_container_mobile" data-testid="sh-callUs-container-mobile">
          <div className="sh_callUs_webpin">{renderWebPin()}</div>
          <div className="sh_callUs_dialing">{renderDialinginfo()}</div>
        </div>
        <div className="sh_callUs_account_info_sharing_msg">{renderAccountInfoSharingMsg()}</div>
      </>
    );
  };

  const renderCallusInfo = () => {
    if (callUsInfo && !_isEmpty(callUsInfo)) {
      if (isMobileLayout()) {
        return callUsInfoMobile();
      }
      return callUsInfoWeb();
    }
    return null;
  };

  return (
    <Fragment>
      <LoaderOverlay display={enableSpinner} />
      {renderCallusInfo()}
    </Fragment>
  );
};

CallUsInfo.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
  pageName: PropTypes.string.isRequired,
};
export default CallUsInfo;
